export const NotesModeEnum = {
  BRIEF: {
    value: 'BRIEF',
    display: 'Brief'
  },
  MEDIUM: {
    value: 'MEDIUM',
    display: 'Medium'
  },
  DETAILED: {
    value: 'DETAILED',
    display: 'Detailed'
  }
};

export const getNotesModeDisplay = (value) => {
  const mode = Object.values(NotesModeEnum).find(m => m.value === value);
  return mode ? mode.display : value;
};

export const notesModeOptions = Object.values(NotesModeEnum);
